module.exports = __webpack_public_path__ + "static/downtown-calhoun-st-441e05129005baa2af6419ce86569103.jpg";